// import PropTypes from 'prop-types';
import React from 'react';
import DropDownButton from '../../ui/PortalDropdown';
import GenericContextItem from './GenericContextItem';

const GenericContextMenu = ({
  callback,
  items,
  icon,
  titleRetrieval,
  callbackRetrieval,
  position,
  styleOverrides,
}) => {
  return (
    <DropDownButton
      title=""
      icon={icon}
      mouseLeave
      hideToggle
      isHoverButton
      skipAssignment
      styleOverrides={{
        background: '#fff',
        ...styleOverrides,
      }}
      style={{
        zIndex: 10000,
        marginBottom: 0,
        right: 0,
        left: 'auto',
        marginTop: 0,
      }}
    >
      {items.map((i, k) => (
        <GenericContextItem
          key={k}
          position={position}
          i={i}
          callbackRetrieval={callbackRetrieval}
          titleRetrieval={titleRetrieval}
          callback={callback}
        />
      ))}
    </DropDownButton>
  );
};

GenericContextMenu.propTypes = {};

export default GenericContextMenu;



// WEBPACK FOOTER //
// ./src/components/buttons/GenericContextMenu/GenericContextMenu.js